import React, { FC } from 'react';
import { LinksStrings } from '../../strings/links.strings';
import { Link } from '@getgo/chameleon-web/react';
import { useTranslation } from 'react-i18next';
import './styles/footer.scss';
import { useUserContext } from '../context/userContext';
import { useFlags } from 'launchdarkly-react-client-sdk';

const Footer: FC = () => {
  const { rebranding } = useFlags();
  const { t, i18n } = useTranslation();
  const { userDetail } = useUserContext();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`footer ${!userDetail ? 'footer-shift-up' : null}`}>
      <section>
        <p>{t('footer.copyright', { currentYear })}</p>
        <p>
          {t('footer.viewPolicy')}
          <Link href={LinksStrings.goToWebinarPrivacyPolicy(i18n.language)} target="_blank">
            {rebranding ? t('footer.policy') : t('footer.policy2')}
          </Link>
        </p>
        <p>{t('footer.reviewPolicy')}</p>
        <p>{rebranding ? t('footer.safeguarding') : t('footer.safeguarding2')}</p>
      </section>
    </footer>
  );
};

export default Footer;
